import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import ArtifactTable from '../ArtifactTable';
import { PreviewTabProps } from '../ReportDialog.props';

const PreviewTab: FC<PreviewTabProps> = ({ hasGeneratedReport, columns, rows }) => (
  <Box data-testid="daily-nav-report-preview">
    {hasGeneratedReport ? (
      <ArtifactTable columns={columns} rows={rows} />
    ) : (
      <Typography variant="body2" color="text.secondary">
        Generate the preview to review the exact CSV that will be finalized and delivered.
      </Typography>
    )}
  </Box>
);

export default PreviewTab;
